<script lang="ts" setup>
import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmPopover,
} from "tir-components";
import { AdapterService } from "./adapter-service";
import { computed, ref } from "vue";
import { TrashIcon } from "tir-style-system/icons/outline";
import { CurrentUser } from "tir-pm-user-core";

/**Api сервис */
const apiService = new AdapterService();

/**Параметры */
const props = defineProps({
  /**Id задачи */
  taskId: { type: Number },
  /**Удаляемый пользователь */
  performerId: { type: Number },
});
/**События */
const emit = defineEmits<{
  /**Удаление пользователя */
  onRemove: [performerId: number];
  /**Поповер открыт */
  open: [];
  /**Поповер закрыт */
  close: [];
}>();

/**Компонент поповера */
const $popover = ref<InstanceType<typeof TirPmPopover>>();
/**Загрузка удаления */
const isLoading = ref(false);

/**Текущий пользователь */
const isCurrentUser = computed(() => CurrentUser.Id == props.performerId);

/**Удаление приглашения */
const removeInvite = async () => {
  isLoading.value = true;
  const response = await apiService.removeEstimateInvite(props.taskId, props.performerId);
  if (response.IsSuccess) emit("onRemove", props.performerId);
  isLoading.value = false;
};
/**Удаление оценки */
const removeEstimate = async () => {
  if (CurrentUser.Id == props.performerId) {
    isLoading.value = true;
    const response = await apiService.removeEstimateTime(props.taskId, props.performerId);
    if (response.IsSuccess) emit("onRemove", props.performerId);
    isLoading.value = false;
  }
};
/**Закрытия окна */
const close = () => {
  $popover.value?.close?.();
};
</script>
<template>
  <TirPmPopover
    ref="$popover"
    :is-disabled="isCurrentUser"
    :position="PopoverPositionEnum.Top"
    @open="emit('open')"
    @close="emit('close')"
  >
    <template #default>
      <TirPmButton
        :is-loading="isLoading"
        :size="TirPmButtonSizeEnum.Small"
        :variant="TirPmButtonVariantEnum.LinkState"
        @click="removeEstimate"
      >
        <template #leftSlot>
          <TrashIcon />
        </template>
      </TirPmButton>
    </template>
    <template #content>
      <div class="remove-confirm">
        <div class="remove-confirm_title">Удалить оценку времени?</div>
        <div class="remove-confirm_content">
          Вы сможете заново пригласить сотрудника для выставления оценки
        </div>
        <div class="remove-confirm_footer">
          <TirPmButton
            :size="TirPmButtonSizeEnum.Small"
            :variant="TirPmButtonVariantEnum.PrimaryState"
            @click="close"
          >
            Отмена
          </TirPmButton>
          <TirPmButton
            :size="TirPmButtonSizeEnum.Small"
            :variant="TirPmButtonVariantEnum.SecondaryState"
            :is-loading="isLoading"
            @click="removeInvite"
          >
            Удалить
          </TirPmButton>
        </div>
      </div>
    </template>
  </TirPmPopover>
</template>
<style lang="scss">
.remove-confirm {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 15.125rem;
  padding: 0.75rem;
  font-size: 0.75rem;
  &_title {
    font-weight: 500;
  }
  &_content {
    color: var(--text-secondary);
  }
  &_footer {
    display: flex;
    gap: 0.5rem;
  }
}
</style>
